import axios from 'axios';

const BRANDFETCH_CLIENT_ID = process.env.NEXT_PUBLIC_BRANDFETCH_CLIENT_ID;
const BRANDFETCH_TOKEN = process.env.NEXT_PUBLIC_BRANDFETCH_TOKEN;
const BRANDFETCH_BASE_URL = process.env.NEXT_PUBLIC_BRANDFETCH_BASE_URL;

export interface BrandfetchBrand {
  brandId: string;
  claimed: boolean;
  domain: string;
  name: string;
  icon: string;
  _score: number;
  qualityScore: number;
  verified: boolean;
}

export interface BrandfetchSearchResponse {
  data: BrandfetchBrand[];
}

export interface LogoFormat {
  src: string;
  background: string | null;
  format: string;
  height: number | null;
  width: number | null;
  size: number;
}

export interface BrandLogo {
  theme: string;
  formats: LogoFormat[];
  tags: string[];
  type: string;
}

export interface BrandDetails {
  brandId: string;
  name: string;
  domain: string;
  logos: BrandLogo[];
}

const brandfetchApiClient = axios.create({
  baseURL: BRANDFETCH_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const searchBrands = async (
  name: string,
): Promise<BrandfetchBrand[]> => {
  if (!name.trim()) {
    return [];
  }

  try {
    const response = await brandfetchApiClient.get<BrandfetchBrand[]>(
      `/search/${encodeURIComponent(name.trim())}`,
      {
        params: {
          c: BRANDFETCH_CLIENT_ID,
        },
      },
    );

    return response.data || [];
  } catch (error) {
    return [];
  }
};

export const getBrandDetails = async (
  brandId: string,
): Promise<BrandDetails | null> => {
  if (!brandId.trim()) {
    return null;
  }

  try {
    const response = await brandfetchApiClient.get<BrandDetails>(
      `/brands/${encodeURIComponent(brandId.trim())}`,
      {
        headers: {
          Authorization: `Bearer ${BRANDFETCH_TOKEN}`,
        },
      },
    );

    return response.data || null;
  } catch (error) {
    // console.error('Brandfetch API error:', error);
    return null;
  }
};
